import "./index.scss";
import Image from "next/image";

export default function Recognized() {
    return (
        <>
        
              {/* Recognized Section */}
        
              <section id="recognized-by" className="recognized-area text-center py-16">
                <h2 className="text-3xl font-bold text-white text-center uppercase tracking-[.08em]">
                  Recognized By
                </h2>
                <div className="w-16 h-1 bg-white mx-auto my-4"></div>
                <div className="max-w-6xl mx-auto px-6 mt-16 flex flex-wrap items-center justify-center gap-10">
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/1.png"
                      alt="Award 1"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/2.png"
                      alt="Award 2"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/3.png"
                      alt="Award 3"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/4.png"
                      alt="Award 4"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/5.png"
                      alt="Award 5"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/6.png"
                      alt="Award 6"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/7.png"
                      alt="Award 7"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/8.png"
                      alt="Award 8"
                      className="object-contain"
                    />
                  </div>
                  <div className="lg:w-1/6 md:w-1/4 awards-img flex items-center justify-center">
                    <Image
                      width={150}
                      height={100}
                      src="/shared/9.png"
                      alt="Award 9"
                      className="object-contain"
                    />
                  </div>
                </div>
              </section>
        </>
    )
}